<template>
  <p>
    source ext id<br>
    {{action.sourceExtId}}
  </p>
</template>

<script>
export default {
  name: 'UserActionInfoEnforcePlayerState',

  props: {
    action: {
      type: Object,
      required: true,
    }
  },
};
</script>
